import { computed, Directive, inject } from '@angular/core';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { PermissionType, WorkflowStep } from '@shared/services/gql.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Directive({ standalone: true })
export class VendorWorkflowDirective {
  private readonly authService = inject(AuthService);
  private readonly workflowQuery = inject(WorkflowQuery);

  readonly userHasVendorPermission = this.authService.$isAuthorized({
    permissions: [PermissionType.PERMISSION_UPDATE_VENDORS],
    sysAdminsOnly: false,
  });

  private isChangeOrdersWorkflowLocked = this.workflowQuery.getLockStatusByWorkflowStepType(
    WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_CHANGE_ORDERS
  );

  disabledUI = computed(
    () => !this.userHasVendorPermission() || this.isChangeOrdersWorkflowLocked()
  );
  vendorActionTooltip = computed(() => {
    if (!this.userHasVendorPermission()) {
      return MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
    }

    if (this.isChangeOrdersWorkflowLocked()) {
      return MessagesConstants.LOCKED_FOR_PERIOD_CLOSE;
    }

    return '';
  });
  vendorActionTooltips = computed(() => {
    const tooltips: string[] = [];

    if (!this.userHasVendorPermission()) {
      tooltips.push(MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION);
    }

    if (this.isChangeOrdersWorkflowLocked()) {
      tooltips.push(MessagesConstants.LOCKED_FOR_PERIOD_CLOSE);
    }

    return tooltips;
  });
}
